const en = {
  // Common
  app_name: "VRS",
  app_subtitle: "Vendor Risk Scanner",
  loading: "Loading...",
  save: "Save",
  cancel: "Cancel",
  back: "Back",
  next: "Next",
  submit: "Submit",
  close: "Close",
  search: "Search",
  filter: "Filter",
  actions: "Actions",
  edit: "Edit",
  delete: "Delete",
  create: "Create",
  download: "Download",
  view: "View",
  details: "Details",
  confirm: "Confirm",
  yes: "Yes",
  no: "No",
  na: "N/A",
  all: "All",
  none: "None",
  or: "or",

  // Status
  status_pending: "Pending",
  status_running: "Running",
  status_completed: "Completed",
  status_failed: "Failed",
  status_active: "Active",
  status_deactivated: "Deactivated",
  status_draft: "Draft",
  status_approved: "Approved",
  status_archived: "Archived",

  // Compliance
  compliant: "Compliant",
  non_compliant: "Non-Compliant",
  at_risk: "At Risk",
  unable_to_determine: "Unable to Determine",
  requires_internal_audit: "Requires Internal Audit",
  not_applicable: "Not Applicable",
  partial: "Partial",

  // Maturity
  maturity_low: "Low",
  maturity_moderate: "Moderate",
  maturity_high: "High",
  maturity_excellent: "Excellent",
  maturity_level: "Maturity Level",

  // Auth
  sign_in: "Sign in",
  sign_up: "Sign Up",
  log_in: "Log in",
  log_out: "Log out",
  email_address: "Email address",
  password: "Password",
  forgot_password: "Forgot password?",
  send_verification_code: "Send verification code",
  verify_and_sign_in: "Verify and sign in",
  enter_credentials: "Enter your credentials to access your account",
  dont_have_account: "Don't have an account?",
  register_here: "Register here",
  already_have_account: "Already have an account?",
  sign_in_link: "Sign in",
  verification_code: "Verification code",
  new_password: "New password",
  reset_password: "Reset password",
  send_reset_code: "Send reset code",
  back_to_login: "Back to login",
  forgot_your_password: "Forgot your password?",
  enter_email_reset: "Enter your email and we'll send you a reset code.",
  password_reset_success: "Password reset!",
  sign_in_new_password: "Sign in with new password",

  // Registration
  registration: "Registration",
  user_information: "User Information",
  scope_questions: "Scope Questions",
  review_submit: "Review & Submit",
  email_verification: "Email Verification",
  select_your_role: "Select Your Role",
  full_name: "Full Name",
  entity_type: "Entity Type",
  entity_email: "Entity Email Address",
  entity_name: "Entity Name",
  entity_url: "Entity URL",
  entity_description: "Entity Description (optional)",
  government_agency: "Government Agency",
  company: "Company",
  individual: "Individual",
  step_x_of_y: "Step {x} of {y}",
  provide_basic_info: "Provide your basic information to create an account",
  help_understand_scope: "Help us understand your compliance scope",
  review_info_submit: "Review your information and submit to receive a verification code",
  enter_6digit_code: "Enter the 6-digit code sent to {email}",
  choose_how_use_vrs: "Choose how you will use VRS",

  // CISA
  cisa_sectors_label: "CISA Critical Infrastructure Sectors",
  cisa_sectors_desc: "Select all sectors that apply to your entity.",

  // PR Gov
  pr_gov_business: "Puerto Rico Government Business",
  pr_gov_q1: "Do you do business with the Government of Puerto Rico?",
  pr_gov_q2: "Do you provide services or perform contracts that involve public functions, public services, or use/investment of public funds, or work under governmental authority?",
  pr_gov_q3: "Do you manage, store, transmit, or otherwise handle governmental data or assets of information, or supply ICT services to agencies?",
  pr_gov_warning: "Answering 'yes' to any of these will include you in a compliance review for vendors to government entities.",

  // Federal Gov
  fed_gov_business: "Federal Government Business",
  fed_gov_q1: "Do you have any contracts with FAR Provisions?",
  fed_gov_q2: "Do you have any contracts with DFARS Provisions?",

  // Roles
  role_compliance: "Compliance",
  role_compliance_desc: "Check your own compliance score",
  role_compliance_subtitle: "Scan your own entity's external-facing assets",
  role_procurement: "Procurement",
  role_procurement_desc: "Check scores of other entities",
  role_procurement_subtitle: "Scan third-party vendors and partners",
  role_regulatory: "Regulatory",
  role_regulatory_desc: "View database of all scans and results",
  role_regulatory_subtitle: "For authorized government regulators only",
  role_regulatory_restricted: "Regulatory accounts require a .gov email domain.",
  complete_registration: "Complete Registration",

  // Dashboard
  dashboard: "Dashboard",
  welcome_back: "Welcome back",
  compliance_overview: "Here is your compliance overview.",
  new_scan: "New Scan",
  compliance_score: "Compliance Score",
  overall_average: "Overall average",
  assets_monitored: "Assets Monitored",
  total_scanned: "Total scanned targets",
  open_findings: "Open Findings",
  across_all_scans: "Across all scans",
  regulations_mapped: "Regulations Mapped",
  active_law_benchmarks: "Active law benchmarks",
  recent_scans: "Recent Scans",
  view_all: "View all",
  no_scans_yet: "No scans yet",
  start_first_scan: "Start your first compliance scan to see results here.",
  start_first_scan_btn: "Start First Scan",
  compliance_overview_title: "Compliance Overview",
  by_category: "By Category",
  no_data: "No data",

  // Sidebar
  nav_dashboard: "Dashboard",
  nav_scans: "Scans",
  nav_laws: "Laws & Regulations",
  nav_categories: "Categories",
  nav_subscriptions: "Subscriptions",
  nav_fines: "Fines",
  nav_public_scores: "Public Scores",
  nav_settings: "Settings",
  nav_admin: "Admin Console",

  // Scans
  scans: "Scans",
  manage_scans: "View and manage your compliance scans.",
  run_scan: "Run Compliance Scan",
  run_scan_desc: "Enter a URL to scan for accessibility and compliance issues.",
  target_url: "Target URL",
  start_scan: "Start Scan",
  scan_initiated: "Scan initiated!",
  scanning: "Scanning {url}",
  scan_results: "Scan Results",
  scanning_in_progress: "Scanning in progress...",
  analyzing_url: "Analyzing {url}",
  scan_may_take: "This may take 1-3 minutes depending on the number of scan types",
  scan_failed: "Scan Failed",
  try_again: "Try Again",
  overall_compliance_score: "Overall Compliance Score",
  law_by_law_results: "Law-by-Law Results",
  all_categories: "All categories",
  sort_by_category: "Sort by Category",
  score_low_first: "Score (Low first)",
  score_high_first: "Score (High first)",
  download_report: "Download Report",
  full_report_pdf: "Full Compliance Report (PDF)",
  summary_report_pdf: "High-Level Summary (PDF)",
  generate_fine_report: "Generate Fine Report",
  what_scan_checks: "What this scan checks",
  scan_disclaimer: "This scan performs a non-intrusive baseline assessment. It does not perform active exploitation or penetration testing.",
  // [Phase 3(c) Stage 3.5, DEF-F4] Describe what the scan ACTUALLY runs against
  // the curated catalog. No OWASP ZAP / OSV-CVE (they do not run). No legal basis.
  scan_check_accessibility: "Accessibility (WCAG 2.1): automated checks for common accessibility barriers. Automated scanning is not exhaustive and is not a substitute for a manual audit.",
  scan_check_privacy: "Privacy notice: checks whether a privacy policy is posted. Included based on your profile.",
  scan_check_cyber: "Puerto Rico cybersecurity (Ley 40-2024): passively-verifiable security-posture checks, included when your applicability profile places you in scope. Most obligations require attestation or audit and are shown separately in your results.",
  scan_check_passive: "This scan reads only public, external assets. It performs no active exploitation, port scanning, or penetration testing.",
  // [Phase 3(c) Sub-stage 2] Ley 40 gate UI chrome (NOT the questions — those are DB-served).
  saving: "Saving...",
  gate_intro: "Answer the following Puerto Rico Ley 40 applicability questions. Leave any as \"Not yet answered\" if you are unsure — your assessment stays provisional until all are answered.",
  gate_not_yet_answered: "Not yet answered",
  gate_view_statute: "View statute (Spanish)",
  gate_result_applies: "Based on your answers, Ley 40 applies to your entity.",
  gate_result_not_apply: "Based on your answers, Ley 40 does not currently apply to your entity.",
  gate_result_provisional: "Cannot yet be determined — {n} question(s) not yet answered.",
  gate_saved: "Applicability answers saved.",
  gate_save_error: "Could not save your answers. Please try again.",
  gate_load_error: "Could not load the applicability questions.",
  reg_gate_step_title: "Ley 40 applicability",
  reg_gate_step_desc: "Answer the Puerto Rico Ley 40 applicability questions, or skip and complete this later in Settings.",
  reg_gate_skip: "Skip for now",
  reg_gate_finish: "Finish",
  settings_ley40_section: "Ley 40 applicability",
  settings_future_note: "A full settings area is coming later. For now you can review and update your Ley 40 applicability answers here.",
  provisional_banner: "Your Ley 40 applicability assessment is provisional — {n} question(s) not yet answered.",
  provisional_cta: "Complete your applicability profile",
  override_title: "Ley 40 for this scan",
  override_entity_applies: "Based on your profile, Ley 40 applies to your entity.",
  override_entity_not_apply: "Based on your profile, Ley 40 does not currently apply to your entity.",
  override_entity_provisional: "Your applicability profile is incomplete (provisional).",
  override_use_profile: "Use my profile determination",
  override_include: "Include Ley 40 for this scan",
  override_exclude: "Exclude Ley 40 for this scan",
  override_note: "This determination is about the entity whose systems are scanned, which may differ from the account holder.",
  covered_title: "Covered systems (declared scope)",
  covered_add: "Add system",
  covered_identifier: "System (hostname / endpoint)",
  covered_exclude: "Exclude from scan",
  covered_basis: "Reason for exclusion (required)",
  covered_basis_required: "Excluding a system requires a written reason.",

  // Scan result labels
  errors: "Errors",
  warnings: "Warnings",
  notices: "Notices",
  must_fix: "Must fix for compliance",
  needs_review: "Needs manual review",
  best_practices: "Best practices",
  findings: "Findings",
  high: "High",
  medium: "Medium",
  low: "Low",
  informational: "Informational",
  parameters: "Parameters",
  scannable: "scannable",
  total_requirements: "total requirements",

  // Results disclaimer
  results_disclaimer: "This assessment evaluates external-facing assets only and does not constitute a comprehensive compliance audit. Consult qualified legal and technical professionals for complete compliance verification.",
  remediation_contact: "For assistance with remediation of identified issues, contact",

  // External scan disclaimer
  external_scan_disclaimer: "External Scan Only: This assessment evaluates {x} of {y} total requirements that are verifiable from external public-facing assets. The remaining {z} requirements cannot be assessed remotely and require an internal compliance audit by a qualified professional.",

  // Categories
  categories: "Categories",
  manage_categories: "Manage compliance assessment categories and methodologies.",
  new_category: "New Category",
  create_category: "Create Category",
  edit_category: "Edit Category",
  category_title: "Title",
  category_description: "Description",
  methodology: "Methodology",
  show_archived: "Show archived",
  no_categories_yet: "No categories yet. Create your first one.",
  archive: "Archive",
  restore: "Restore",

  // Laws
  laws_regulations: "Laws & Regulations",
  manage_laws: "Configure compliance rules and scannable parameters for each law.",
  add_new_law: "Add New Law",
  law_title: "Law Title",
  jurisdiction: "Jurisdiction",
  source_url: "Source URL",
  description_summary: "Description / Summary",
  scannable_parameters: "Scannable Parameters",
  fine_schedule: "Fine Schedule",
  save_as_draft: "Save as Draft",
  approve_activate: "Approve & Activate",
  basic_information: "Basic Information",
  define_parameters: "Define Scannable Parameters",
  review_save: "Review & Save",
  parameter_name: "Parameter Name",
  scan_method: "Scan Method",
  externally_scannable: "Externally scannable",
  requires_audit: "Requires internal audit",
  compliance_criteria: "Compliance Criteria",
  weight: "Weight",
  add_parameter: "Add Parameter",
  can_result_in_fines: "Can this law result in fines?",
  violation_description: "Violation Description",
  min_amount: "Min Amount",
  max_amount: "Max Amount",
  frequency: "Frequency",
  add_violation: "Add Violation",
  per_incident: "Per Incident",
  per_day: "Per Day",
  per_record: "Per Record Affected",
  flat_fee: "Flat Fee",

  // Admin
  admin_console: "Admin Console",
  super_admin_console: "Super Admin Console",
  manage_platform: "Manage users, view activity, and configure the platform.",
  user_management: "Users",
  activity_log: "Activity Log",
  usage: "Usage",
  exemptions: "Exemptions",
  system_settings: "System Settings",
  create_user: "Create User",
  change_role: "Change Role",
  reset_password_action: "Reset Password",
  view_activity: "View Activity",
  deactivate: "Deactivate",
  reactivate: "Reactivate",
  total_users: "Total Users",
  active_subscriptions: "Active Subscriptions",
  total_scans_run: "Total Scans",
  scans_this_month: "Scans This Month",

  // Billing
  billing_subscription: "Billing & Subscription",
  manage_billing: "Manage your subscription plan and payment details.",
  current_plan: "Current Plan",
  manage_subscription: "Manage Subscription",
  scans_used: "Scans Used",
  next_billing: "Next Billing",
  payment_method: "Payment Method",
  available_plans: "Available Plans",
  subscribe: "Subscribe",
  one_time_scan: "One-Time Scan",
  subscription_required: "Subscription Required",

  // Fines
  fines_management: "Fines Management",
  fines_desc: "Issue, track, and manage regulatory fines.",
  total_fines: "Total Fines",
  active_issued: "Active (Issued)",
  total_amount: "Total Amount",
  entity: "Entity",
  amount: "Amount",
  date_issued: "Date Issued",
  due_date: "Due Date",
  status: "Status",
  fine_status_draft: "Draft",
  fine_status_issued: "Issued",
  fine_status_paid: "Paid",
  fine_status_disputed: "Disputed",
  issue_fine_ticket: "Issue Fine Ticket",
  save_fine_draft: "Save as Draft",
  select_violations: "Select Violations",
  fine_schedule_not_configured: "Fine schedule not configured",
  fine_disclaimer: "This assessment is based on automated scanning of external-facing assets. The issuing authority should verify findings independently before enforcement action.",

  // Public Score
  public_compliance_profile: "Public Compliance Profile",
  public_profile_desc: "Share your compliance score publicly via QR code or URL.",
  make_score_public: "Make my compliance score public",
  public_toggle_desc: "When enabled, anyone with the link or QR code can view your overall score and category breakdown.",
  your_qr_code: "Your QR Code",
  qr_desc: "Share this QR code with vendors, partners, or clients. Anyone who scans it can view your public compliance score.",
  public_url: "Public URL",
  download_png: "Download PNG",
  download_svg: "Download SVG",
  preview: "Preview",
  copy_url: "Copy URL",
  profile_preview: "Public Profile Preview",
  score_not_available: "Score Not Available",
  score_not_public: "This entity's compliance score is not publicly available.",
  verified_by_vrs: "Verified by VRS",
  category_scores: "Category Scores",
  last_scanned: "Last scanned",
  no_scan_results: "No scan results yet. Run a scan to populate your public profile.",

  // Landing
  landing_badge: "Regulatory Compliance Scanning Platform",
  landing_hero: "Compliance Scanning,",
  landing_hero_accent: "Verified.",
  landing_desc: "Scan websites and external-facing assets against applicable laws and regulations. Get deterministic, evidence-backed compliance scores with full audit trails.",
  get_started_free: "Get Started Free",
  landing_disclaimer: "VRS provides automated preliminary compliance assessments. Results should be verified by qualified professionals.",
  landing_features_title: "Everything you need for compliance management",
  landing_cta_title: "Ready to verify your compliance?",
  landing_cta_desc: "Start with a free scan. No credit card required.",
  start_scanning: "Start Scanning",
  privacy_policy: "Privacy Policy",
  terms_of_service: "Terms of Service",
  contact: "Contact",
  powered_by: "Powered by VRS",
  cybercheck_product: "A CyberCheck LLC Product",

  // Features
  feature_multi_law: "Multi-Law Scanning",
  feature_multi_law_desc: "Automated compliance checks against WCAG, HIPAA, GLBA, CMMC, Ley 40-2024, and more.",
  feature_deterministic: "Deterministic Results",
  feature_deterministic_desc: "Every finding traces to a specific configured rule. No AI guessing or hallucination.",
  feature_fines: "Regulatory Fines",
  feature_fines_desc: "Generate fine tickets with legally-referenced violation schedules.",
  feature_qr: "Public QR Scores",
  feature_qr_desc: "Share your compliance score via branded QR code with vendors and partners.",
  feature_reports: "Executive Reports",
  feature_reports_desc: "Downloadable PDF reports with category breakdowns and remediation guidance.",
  feature_rbac: "Role-Based Access",
  feature_rbac_desc: "Compliance, Procurement, Regulatory, Legal Entry, and Admin roles with RBAC.",

  // 404
  page_not_found: "Page not found",
  page_not_found_desc: "The page you're looking for doesn't exist or has been moved.",
  go_back: "Go Back",

  // Topbar
  search_placeholder: "Search scans, laws, assets...",
  notifications: "Notifications",
  profile: "Profile",

  // Ley 40
  externally_scannable_params: "Externally Scannable Parameters",
  privacy_notice_art5: "Privacy Notice (Art. 5) — Assessed under Privacy Policy category",
  privacy_notice_art5_desc: "The 8th externally scannable requirement (Privacy Notice) is evaluated separately under the Ley 39-2012 Privacy Policy scan results above.",
  internal_audit_requirements: "requirements require internal audit (not externally scannable)",
};

export default en;
